import { RouteType } from "../../../types/RouteType";

const YardInventoryRoute: RouteType = {
  name: "Yard Inventory",
  path: "/yard/inventory",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Yard Inventory",
      enableBackButton: true,
      component: () => import("./YardInventory.Header"),
    },
    body: {
      component: () => import("./YardInventory.Body"),
      grayBackground: true,
    },
  },
  group: 'Yard',
  requiresAuth: true,
  requiresPermission: false,
  hidden: true,
};

export default YardInventoryRoute;
